import * as d3 from 'd3'
import { formatCompactAmount } from '@/utils/utils'

const COMPACT_WIDTH_THRESHOLD = 600
const fullFormat = d3.format(',.2f')

function getKpiPanelWidth() {
  if (typeof document === 'undefined') return null
  const panel = document.querySelector('.kpis')
  return panel ? panel.offsetWidth : null
}

export function formatResponsiveAmount(value) {
  const panelWidth = getKpiPanelWidth()

  if (panelWidth != null && panelWidth < COMPACT_WIDTH_THRESHOLD) {
    return formatCompactAmount(value)
  }

  return fullFormat(value)
}
